// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1Drw-","info":"PatientInfo_info__n4WzM"};